/**
 * Case-insensitive substring match of a trimmed query against candidate
 * values — the shared predicate behind the tables' global filters. An empty
 * or whitespace-only query matches everything.
 */
export function matchesSearch(values: readonly (string | null | undefined)[], query: string): boolean {
    const needle = query.trim().toLowerCase();
    if (!needle) return true;
    return values.some((value) => value?.toLowerCase().includes(needle));
}
